export default __webpack_public_path__ + "static/media/Q7_4_resized.d4a05d87.jpg";